import { render } from "./IconBlock.vue?vue&type=template&id=570a1c46"
import script from "./IconBlock.vue?vue&type=script&lang=js"
export * from "./IconBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__